import React from 'react';
import Button from '../../../components/ui/Button';

const NumericKeypad = ({ onKeyPress, onClear, disabled = false, compact = false }) => {
  const keys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['*', '0', '#']
  ];

  const handleKeyPress = (key) => {
    if (disabled) return;
    onKeyPress(key);
  };

  return (
    <div className={`grid grid-cols-3 ${compact ? 'gap-3' : 'gap-4'} max-w-sm mx-auto`}>
      {keys?.flat()?.map((key) => (
        <Button
          key={key}
          variant={key === '*' || key === '#' ? 'secondary' : 'outline'}
          size={compact ? 'lg' : 'xl'}
          onClick={() => handleKeyPress(key)}
          disabled={disabled}
          className={`${compact ? 'h-14 w-14 text-xl' : 'h-16 w-16 text-2xl'} font-semibold touch-feedback hover:elevation-1 transition-all duration-150`}
        >
          {key}
        </Button>
      ))}
      <div className="col-span-3 mt-4">
        <Button
          variant="ghost"
          size={compact ? 'md' : 'lg'}
          fullWidth
          onClick={onClear}
          disabled={disabled}
          iconName="Delete"
          iconPosition="left"
          className="touch-feedback text-text-secondary hover:text-error"
        >
          Löschen
        </Button>
      </div>
    </div>
  );
};

export default NumericKeypad;